export enum Platform {
	MT4 = 'mt4',
	MT5 = 'mt5',
	MT4_MT5 = 'mt4_mt5',
	ANOTHER = 'another',
}
